export default __webpack_public_path__ + "static/media/Advice.0c2796d7.svg";